/**
 * Curated Lucide icons for `SnapshotAction.iconName` across v2 surfaces
 * (`ChatActions`, `HomeActionCard`, etc.). One registry keeps n8n-driven
 * names consistent everywhere.
 *
 * Add new icons as named imports here and in `SNAPSHOT_ACTION_ICON_REGISTRY`.
 * Avoid `import * as` from `lucide-react` — it bloats the bundle.
 */

import {
  ArrowRight,
  Calendar,
  CheckCircle2,
  Clock,
  FileText,
  Lightbulb,
  MessageCircle,
  Mic,
  Plus,
  Search,
  Sparkles,
  Target,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react';

export const SNAPSHOT_ACTION_ICON_REGISTRY: Record<string, LucideIcon> = {
  ArrowRight,
  Calendar,
  CheckCircle2,
  Clock,
  FileText,
  Lightbulb,
  MessageCircle,
  Mic,
  Plus,
  Search,
  Sparkles,
  Target,
  TrendingUp,
  /** Alias for snapshot payloads that use Lucide-style "TrendUp" naming */
  TrendUp: TrendingUp,
  Users,
};

/**
 * Resolve a snapshot action icon, or `null` when `name` is missing or unknown.
 * Call sites that always show a disc (e.g. home cards) typically use
 * `resolveSnapshotActionIcon(name) ?? Sparkles`.
 */
export function resolveSnapshotActionIcon(name: string | undefined): LucideIcon | null {
  if (!name) return null;
  return SNAPSHOT_ACTION_ICON_REGISTRY[name] ?? null;
}
